import Vue from 'vue'
import Qs from 'qs'
import axios from 'axios'
import store from '../store'
import { MessageBox, Message, Loading } from 'element-ui'
import { commonApi } from '@/api/common'
import {host_admin_gateway_func} from '@/api/host'
import jwtdecode from 'jwt-decode'
axios.defaults.timeout = 10000;

let pending = [] //声明一个数组用于存储每个ajax请求的取消函数和ajax标识
let cancelToken = axios.CancelToken
let removePending = (config) => {
    for (let p in pending) {
        if (pending[p].u === config.url + '&' + config.method) {
            //当当前请求在数组中存在时执行函数体
            pending[p].f() //执行取消操作
            pending.splice(p, 1) //把这条记录从数组中移除
        }
    }
}

//请求拦截器
axios.interceptors.request.use(
    config => {
        const token = store.state.userInfo.token;
        if (token) {
            config.headers['Authorization'] = `Bearer ${token}`;
        }
        if (config.needLoading) {
            EpetJs.Const.loading = Loading.service({
                background: 'rgba(255,255,255,.3)',
            })
        }
        //取消重复请求
        if (config.cancelRepeat) {
            removePending(config) //在一个ajax发送前执行一下取消操作
            config.cancelToken = new cancelToken((c) => {
                // ajax标识用请求地址&请求方式拼接的字符串
                pending.push({ u: config.url + '&' + config.method, f: c })
            })
        }
        //刷新token
		if (config.url.indexOf('sso/login') === -1 && EpetJs.Common.getRoute().openSingle != 1) {
			if (token) {
				/*判断token是否将要过期*/
				if (EpetJs.Helper.isTokenExpired() && config.url.indexOf('sso/login') === -1 && config.url != commonApi.refreshTokenUrl && config.url != commonApi.businessRefreshTokenUrl) {
					/*判断是否正在刷新*/
					if (!EpetJs.Const.isFreshToken) {
						/*将刷新token的标志置为true*/
						EpetJs.Const.isFreshToken = true
						/*发起刷新token的请求*/
                        const refreshTokenUrl = localStorage.getItem(EpetJs.Const.LoginTypeName) == 'business' ? commonApi.businessRefreshTokenUrl : commonApi.refreshTokenUrl
						EpetJs.Common.ajax('get', refreshTokenUrl, {
							platform: store.state.platformName
						}).then(res => {
							if (res && res.data.data && res.data.data.token) {
								/*将标志置为false*/
								EpetJs.Const.isFreshToken = false
								/*成功刷新token*/
								config.headers['Authorization'] = `Bearer ${res.data.data.token}`;
								/*更新token*/
								let expire = jwtdecode(res.data.data.token).exp
								store.commit('saveToken', {
									token: res.data.data.token,
									refreshToken: res.data.data.refresh_token,
									expire: expire
								})
								/*执行数组里的函数,重新发起被挂起的请求*/
								EpetJs.Helper.execRequest(res.data.data.token)
								/*清空数组中保存的请求*/
								EpetJs.Const.requestList = []
							} else {
								EpetJs.Common.message({
									message: 'token失效，请重新登录',
									type: "warning"
								});
								store.commit('changeLoginDialog', true)
							}
						})
					}
					/*把请求(token)=>{....}都push到一个数组中*/
					let retry = new Promise((resolve, reject) => {
						EpetJs.Helper.addRequest((token) => {
							config.headers.Authorization = 'Bearer ' + token
							/*将请求挂起*/
							resolve(config)
						})
					})
					return retry
				}
			}
		}

        // 溯源系统独立，登录获取的token可能无法访问中台网关，需要转发一下
        let gateway = host_admin_gateway_func('', '');
        if (config.url.indexOf(gateway) !== -1) {
            //拆解请求地址
            let path = config.url.substr(gateway.length);
            //拆解服务名
            let serviceName = path.split('/')[0]
            if (!serviceName) {
                return config;
            }
            //wms转发地址
            config.url = commonApi.transferGatewayUrl;
            config.data = {
                service_name:serviceName,
                uri:path.substr(serviceName.length),
                request_method:config.method, //原始请求方式
                data:config.params ? config.params : config.data
            };
            //统一wms网关请求方式为post
            config.method = 'post';
        }
		return config;
    },
    err => {
        return Promise.reject(err);
    }
)

//添加响应拦截器
axios.interceptors.response.use(
    response => {
        removePending(response.config)
        if (typeof (response.data.status_code) != 'undefined') {
            let code = parseInt(response.data.status_code)
            switch (code) {
                case 200:
                    return response
                    break
                case 400:
                    EpetJs.Common.message({
                        message: response.data.message,
                        type: "warning"
                    });
                    if(response.config.customError) {
                        return response
                    }
                    break
                case 401:
                    if(response.config.customError) {
                        return response
                    }else {
                        store.commit('changeLoginDialog', true)
                    }
                    break
                case 403:
                    EpetJs.Common.message({
                        message: response.data.message,
                        type: "warning"
                    });
                    if(response.config.customError) {
                        return response
                    }
                    break
                case 404:
                    EpetJs.Common.message({
                        message: '接口不存在',
                        type: "warning"
                    });
                    if(response.config.customError) {
                        return response
                    }
                    break
                default:
                    EpetJs.Common.message({
                        message: response.data.message,
                        type: "warning"
                    });
                    if(response.config.customError) {
                        return response
                    }
                    break
            }
        } else {
            return response;
        }
    },
    error => {
        if (error.response) {
            switch (error.response.status) {
                case 401:
                    store.commit('changeLoginDialog', true)
                    break
                case 500:
                    EpetJs.Common.message({
                        message: '接口超时',
                        type: "warning"
                    });
                    break
                case 404:
                    EpetJs.Common.message({
                        message: '接口不存在',
                        type: "warning"
                    });
                    break
            }
        }
        return Promise.reject(error);
    }
);

export const EpetJs = {
    Const: {
        PROTOCOL: 'http', //协议(http、https)
        DOMAIN: '.epet.com', //域名
        RESOURCE_URL: '', //静态资源路径
        API_PATH: '118.31.218.212:9009', //接口URL头
        VERSION: 0, //版本号
        ENV: 'product', //开发环境(dev、sx、local)
        PORT: {
            wap: 8080,
            sale: 9090,
            hk: 1010
        },
        successStatus: 200,
        requestList: [],//被挂起的请求数组
        isFreshToken: false,//是否正在请求刷新token
        loading: '',
        LoginTypeName: 'alliance.login.type',
        SavePwdAccountName: 'alliance.login.account',
        SavePwdName: 'alliance.login.savePwd'
    },
    Common: {
        post: function (url, params = {}, opt = {}) {
            var urlValue = EpetJs.Helper.createApiUrl(url);
            return EpetJs.Helper.ajaxRequest(urlValue, params, 'POST', opt);
        },
        get: function (url, params = {}, opt = {}) {
            var urlValue = EpetJs.Helper.createApiUrl(url);
            return EpetJs.Helper.ajaxRequest(urlValue, params, 'GET', opt);
        },
        patch: function (url, params = {}, opt = {}) {
            var urlValue = EpetJs.Helper.createApiUrl(url);
            return EpetJs.Helper.ajaxRequest(urlValue, params, 'PATCH', opt);
        },
        delete: function (url, params = {}, opt = {}) {
            var urlValue = EpetJs.Helper.createApiUrl(url);
            return EpetJs.Helper.ajaxRequest(urlValue, params, 'DELETE', opt);
        },
        put: function (url, params = {}, opt = {}) {
            var urlValue = EpetJs.Helper.createApiUrl(url);
            return EpetJs.Helper.ajaxRequest(urlValue, params, 'PUT', opt);
        },
        ajax(type, url, params = {}, opt = {}) {
            const upperCasetype = type.toUpperCase()
            const urlValue = EpetJs.Helper.createApiUrl(url)
            if (opt.needLoading) {
                EpetJs.Const.loading = Loading.service({
                    background: 'rgba(255,255,255,.3)',
                })
            }
            return EpetJs.Helper.ajaxRequest(urlValue, params, upperCasetype, opt)
        },
        confirm: function (content, title, options) {
            return new Promise((resolve, reject) => {
                MessageBox.confirm(content, title, options)
                    .then(response => {
                        resolve(response);
                    })
                    .catch(err => {
                        reject(err)
                    })
            });
        },
        alert: function (content, title, options) {
            return new Promise((resolve, reject) => {
                MessageBox.alert(content, title, options)
                    .then(response => {
                        resolve(response);
                    })
            })
        },
        message: function (options) {
            // return new Promise((resolve, reject) => {
            Message(options)
            // .then(response => {
            //     resolve(response);
            // })
            // })
        },
        loading: function (content, time, callback) {
            let t = time ? time : 1000
            const loading = Loading.service({
                lock: true,
                text: content,
                spinner: 'el-icon-loading',
                background: 'rgba(255,255,255, 0.7)'
            })
            setTimeout(() => {
                loading.close();
                callback && callback()
            }, t);
        },
        /**
         * 需手动关闭loading
         */
        showLoading: function (content, isShowBg) {
            const bg = isShowBg ? 'rgba(255,255,255, 0.7)' : 'rgba(255,255,255, 0)'
            EpetJs.Const.loading = Loading.service({
                lock: true,
                text: content ? content : '正在处理，请稍等',
                spinner: 'el-icon-loading',
                background: bg
            })
        },
        hideLoading: function () {
            if (EpetJs.Const.loading) {
                EpetJs.Const.loading.close()
            }
        },
        createUrl: function (app, arg) {
            var apps = app.split(":");
            var domain = location.host,
                app = apps[0];
            var cookDomain = EpetJs.Const.DOMAIN;
            var port = app ? ':' + EpetJs.Const.PORT[app] : '';
            if (apps.length > 1) {
                if (app == 'hk') {
                    if (EpetJs.Const.ENV == 'local') {
                        cookDomain = '.local.epetht.com' + port;
                    } else if (EpetJs.Const.ENV == 'dev') {
                        cookDomain = '.hk.epet.com';
                    } else {
                        cookDomain = '.epetht.com';
                    }
                } else {
                    if (EpetJs.Const.ENV == 'local') {
                        cookDomain = '.local.epet.com' + port;
                    } else if (EpetJs.Const.ENV == 'dev') {
                        cookDomain = '.dev.epet.com';
                    } else if (EpetJs.Const.ENV == 'sx') {
                        cookDomain = '.sx.epet.com';
                    } else {
                        cookDomain = '.epet.com';
                    }
                }
                domain = apps[0] + cookDomain;
                app = apps[1];
            }
            var url_end = app == '' || app.charAt(app.length - 1) == '/' ? '' : '.html';
            arg = $.type(arg) == 'undefined' ? '' : arg;
            if (arg) {
                var prefix = arg.charAt(0);
                if (prefix == '?') {
                    url_end += arg;
                    arg = '';
                } else if (prefix == '&') {
                    arg = '--' + arg.replace("&", '-');
                } else {
                    arg = '/' + arg;
                }
            }

            return EpetJs.Common.formatUrl(EpetJs.Const.PROTOCOL + '//' + domain + '/' + app + arg + url_end);
        },


        /**
         * 格式化一个地址（拼接fw、拼接地址栏参数）
         *@param {string} url url地址
         *@param {object} arg 将要拼结的参数对象
         *用法示例：EpetJs.Common('list/goods.html','pet_type')
         */
        formatUrl: function (url, arg) {
            var devParam = EpetJs.Helper.getUrlParam('dev');
            if (url == '' || url == undefined) return "";
            if (typeof (arg) != "object") arg = {};
            if (EpetJs.Helper.getUrlParam('dev', url) == null && devParam != null) arg.dev = devParam;
            var linkPrams = (url.indexOf('?') > 0) ? "&" : "?";
            url = EpetJs.Helper.isEmptyObject(arg) ? url : url + linkPrams;
            for (var index in arg) {
                url += index + "=" + arg[index] + "&";
            }
            return url.replace(/&$/, '');
        },
        locationTo: function (url, strJson) {
            var relurl = document.location.href;
            return window.location.href = EpetJs.Common.formatUrl(EpetJs.Common.createUrl(url, strJson), {
                'referrer': escape(relurl)
            });
        },
        /**
         * [getImg description]
         * @param  {[string]} url    [原图片地址]
         * @param  {[int]} width  [图片宽度]
         * @param  {[int||string]} height  [图片高度] height为“”空，表示高宽一样
         * @param  {[string]} type   [裁剪类型：a=缩放，c=裁剪，b=补白,s = 索引按高度切割]
         * @param  {[bool]} gifFilter  为true 表示对gif图片不进行裁剪处理
         * @return {[type]}        [新的图片地址]
         */
        getCutImage: function (url, width, height, type, gifFilter) {
            if (url == '' || typeof url == 'undefined') return '';
            var reg = /@!water/;
            if (reg.test(url)) {
                url = url.replace(/@!water/g, '');
            }
            if (gifFilter && /\.(gif)$/.test(url)) {
                return url;
            }
            var fillUrl = url + "?x-oss-process=style/fill&$1=" + width + "&$2=";
            var cutUrl = url + "?x-oss-process=style/cut&$1=" + width + "&$2=";
            var aUrl = url + "?x-oss-process=style/waterfall&$1=" + width;
            var sUrl = url + "?x-oss-process=style/index_y&$1=" + height + "&$2=";
            switch (type) {
                case 'b':
                    if (typeof height == "number") {
                        return fillUrl + height;
                    }
                    return fillUrl + width;
                case 'a':
                    return aUrl;
                case 's':
                    return sUrl;
                default:
                    if (typeof height == "number") {
                        return cutUrl + height; //一般性裁剪
                    }
                    return cutUrl + width;
            }
        },
        getGoodsImage: function (url, width) {
            return EpetJs.Common.getCutImage(url, width, 0, 'b');
        },

        /**
         * 返回静态资源完整路径
         *@param {string} urlName 静态资源的一个相对url地址
         *示例：EpetJs.Common.resUrl('wap/images/img.png')
         **/
        resUrl: function (urlName) {
            var url = urlName || "";
            return EpetJs.Const.RESOURCE_URL + url;
        },

        /**
         * 获取页面cookie值
         * @param {string} name cookie的key
         * */
        getcookie: function (name) {
            var arr, reg = new RegExp("(^| )" + name + "=([^;]*)(;|$)");
            if (arr == document.cookie.match(reg)) {
                return unescape(arr[2]);
            } else {
                return null;
            }
        },

        /**
         * 设置页面cookie
         * @param {string} cookieName cookie的key
         * @param {string} cookieValue cookie值
         * @param {string} time cookie的过期时间
         * *s20是代表20秒  h是指小时，如12小时则是：h12  d是天数，30天则：d30
         * */
        setcookie: function (cookieName, cookieValue, time) {
            var strsec;
            var str1 = time.substring(1, time.length) * 1;
            var str2 = time.substring(0, 1);
            var path = '/';
            if (str2 == "s") {
                strsec = str1 * 1000;
            } else if (str2 == "h") {
                strsec = str1 * 60 * 60 * 1000;
            } else if (str2 == "d") {
                strsec = str1 * 24 * 60 * 60 * 1000;
            }
            var exp = new Date();
            exp.setTime(exp.getTime() + strsec * 1);
            document.cookie = cookieName + "=" + escape(cookieValue) + ";expires=" + exp.toGMTString() + ";path=" + path;
        },

        /**
         *字符串转json对象
         *@param{string} str json字符串
         *@param {string} line json字符串分隔符
         **/
        strToJson: function (str, line) {
            var arr = str.split(line);
            var jsonObj = {};
            for (var i = 0; i < arr.length; i++) {
                var list = arr[i].split(":")
                var key = list[0];
                var value = list[1]
                jsonObj[key] = value;
            }
            return jsonObj;
        },
        //获取链接参数
		getRoute: function (url) {
			url = url || location.href
			var queryItems = url.split('?')
			var query = ''
			//单页应用微信qq分享后可能有多个'?'，取最后的那个
			if (queryItems.length > 1) {
				query = url.split('?')[queryItems.length - 1]
			}

			if (!query) {
				return {}
			}
			var objQuery = {}
			var strs = query.split('&')
			strs.forEach((item) => {
				if (item) {
					objQuery[item.split('=')[0]] = decodeURIComponent(item.split('=')[1])
				}
			})
			return objQuery
		},
        // 树形结构数据查找
		findTree(treeList, childName,valueName,value) {
			if (!treeList) { return; }
			for (const item of treeList) {
				if (item[valueName] === value) { return item; }
				const child = EpetJs.Common.findTree(item[childName],childName,valueName, value);
				if (child) { return child; }
			}
		}
    },
    Helper: {
        // 格式化时间，待优化
        formatTime: function (timeStr, format) {
            var res = '';
            if (format == "yyyy-mm-dd") {
                res = timeStr.substring(0, 10);
            } else if (format == "hh:ii:ss") {
                res = timeStr.substring(11, 19);
            } else if (format == "yyyy-mm-dd hh:ii:ss") {
                res = timeStr.substring(0, 10) + ' ' + timeStr.substring(11, 19);
            }

            return res;
        },
        /**
         * 生成api接口请求地址
         * @param {string} apiName 接口相对地址
         * */
        createApiUrl: function (apiName) {
            return apiName;
        },
        /**
         * ajax请求
         * @param {string} url 请求的接口地址
         * @param {object} data 向服务器发送的请求数据
         * @param {function} callback 请求成功后的回调方法
         * */
        ajaxRequest: function (url, params = {}, type, opt = {}) {
            const jsonType = { 'Content-Type': 'application/json;charset=UTF-8' }
            const formType = { 'Content-Type': 'application/x-www-form-urlencoded' }
            const param = {
                method: type,
                withCredentials: true,
                headers: opt && opt.form ? formType : jsonType,
                cancelRepeat: opt && opt.cancelRepeat ? opt.cancelRepeat : false,
                needLoading: opt && opt.needLoading ? opt.needLoading : false,
                customError: opt && opt.customError ? opt.customError : false,
            }
            switch (type) {
                case 'GET':
                    param.params = params
                    break
                default:
                    param.data = opt && opt.form ? Qs.stringify(params) : params
            }

            return new Promise((resolve, reject) => {
                axios(url, param)
                    .then(response => {
                        resolve(response);
                        setTimeout(() => {
                            EpetJs.Common.hideLoading()
                        }, 500)
                    })
                    .catch(err => {
                        reject(err)
                        setTimeout(() => {
                            EpetJs.Common.hideLoading()
                        }, 500)
                    })
            })

        },
        /**
         * 是否被定义
         * */
        isset: function (val) {
            return typeof (val) != 'undefined';
        },

        /**
         * 获取所有地址栏参数字符串
         * a=1&b=2&c=3
         * @returns {string}
         */
        getLocationQueryString: function () {
            var queryString = window.location.search;
            return queryString ? decodeURI(queryString.substr(1)) : "";
        },

        /**
         * 将URl参数字符串转换为json格式，
         * a=1&b=2&c=3 转换为  {a="1", b="2", c="3"}
         * @param data
         * @returns {{}}
         */
        locationQueryStringToJson: function (url_str) {
            var reg_para = /([^&=]+)=([\w\W]*?)(&|$|#)/g,
                ret = {},
                result;
            while ((result = reg_para.exec(url_str)) != null) {
                ret[result[1]] = result[2];
            }
            return ret;
        },


        /**
         * 获取URL某个参数
         * @param {string} name url地址中的某个参数key
         * @param {string} url url地址（为空的时候，表示从当前页面url地址中获取参数）
         * 使用示例：EpetJs.Common.getUrlParam(name,[url])
         */
        getUrlParam: function (name, url) {
            var items = null;
            if (url) {
                var pattern = new RegExp("[?&]" + name + "=([^&]+)", "g");
                var matcher = pattern.exec(url);
                if (null != matcher) {
                    try {
                        items = decodeURIComponent(decodeURIComponent(matcher[1]));
                    } catch (e) {
                        try {
                            items = decodeURIComponent(matcher[1]);
                        } catch (e) {
                            items = matcher[1];
                        }
                    }
                }
            } else {
                var params = EpetJs.Helper.locationQueryStringToJson(EpetJs.Helper.getLocationQueryString());
                items = params[name] ? params[name] : null;
            }
            return items;
        },
        isEmptyObject: function (obj) {
            for (var key in obj) {
                return false; /*有值*/
            }
            return true; /*无值*/
        },

        objTokey: function (obj, keys) {
            var n = keys.length,
                key = [];
            while (n--) {
                key.push(obj[keys[n]]);
            }
            return key.join('|');
        },

        /**判断数组中是否存在另一数组 **/
        isContained: function (a, b) {
            if (!(a instanceof Array) || !(b instanceof Array)) return false;
            if (a.length < b.length) return false;

            for (var i = 0, len = b.length; i < len; i++) {
                if (a.indexOf(b[i]) == -1) return false;
            }
            return true;
        },

        /**
         * 数组对象数据去重复
         * @param  {[array]} array    需要去重的数组
         * @param  {[string]} keys    比较对象的key值，如果有一样的就去重复
         * **/
        uniqeByKeys: function (array, keys) {
            var _self = this;
            var arr = [];
            var hash = {};
            for (var i = 0, j = array.length; i < j; i++) {
                var k = EpetJs.Helper.objTokey(array[i], keys);
                if (!(k in hash)) {
                    hash[k] = true;
                    arr.push(array[i]);
                }
            }
            return arr;
        },
        jsonToQueryString: function (param, key) {
            var paramStr = "";
            var param_type = $.type(param);
            if (param_type == 'string' || param_type == 'number' || param_type == 'boolean') {
                paramStr += "&" + key + "=" + encodeURIComponent(param);
            } else {
                $.each(param, function (i) {
                    var k = key == null ? i : key + (param_type == 'array' ? "[" + i + "]" : "." + i);
                    paramStr += '&' + EpetJs.Helper.jsonToQueryString(this, k);
                });
            }
            return paramStr.substr(1);
        },
        /**
         * 对象深拷贝
         * @param obj
         * @returns {*}
         */
        deepClone: function (obj) {
            if (obj === null) return null
            if (typeof obj !== 'object') return obj;
            if (obj.constructor === Date) return new Date(obj);
            if (obj.constructor === RegExp) return new RegExp(obj);
            var newObj = new obj.constructor();  //保持继承链
            for (var key in obj) {
                if (obj.hasOwnProperty(key)) {   //不遍历其原型链上的属性
                    var val = obj[key];
                    newObj[key] = typeof val === 'object' ? arguments.callee(val) : val; // 使用arguments.callee解除与函数名的耦合
                }
            }
            return newObj;
        },
        /**
         * base64解码
         */
        base64decode(str) {
            var base64DecodeChars = new Array(
                -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1,
                -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1,
                -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, 62, -1, -1, -1, 63,
                52, 53, 54, 55, 56, 57, 58, 59, 60, 61, -1, -1, -1, -1, -1, -1,
                -1, 0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14,
                15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, -1, -1, -1, -1, -1,
                -1, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40,
                41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, -1, -1, -1, -1, -1);
            var c1, c2, c3, c4;
            var i, len, out;
            len = str.length;
            i = 0;
            out = "";
            while (i < len) {

                do {
                    c1 = base64DecodeChars[str.charCodeAt(i++) & 0xff];
                } while (i < len && c1 == -1);
                if (c1 == -1)
                    break;

                do {
                    c2 = base64DecodeChars[str.charCodeAt(i++) & 0xff];
                } while (i < len && c2 == -1);
                if (c2 == -1)
                    break;
                out += String.fromCharCode((c1 << 2) | ((c2 & 0x30) >> 4));

                do {
                    c3 = str.charCodeAt(i++) & 0xff;
                    if (c3 == 61)
                        return out;
                    c3 = base64DecodeChars[c3];
                } while (i < len && c3 == -1);
                if (c3 == -1)
                    break;
                out += String.fromCharCode(((c2 & 0XF) << 4) | ((c3 & 0x3C) >> 2));

                do {
                    c4 = str.charCodeAt(i++) & 0xff;
                    if (c4 == 61)
                        return out;
                    c4 = base64DecodeChars[c4];
                } while (i < len && c4 == -1);
                if (c4 == -1)
                    break;
                out += String.fromCharCode(((c3 & 0x03) << 6) | c4);
            }
            return out;
        },
        /*
        * 判断token是否过期
        */
        isTokenExpired() {
            let expiredTime = store.state.userInfo.expire
            let nowTime = new Date().getTime() / 1000
            const result = (expiredTime - nowTime) < 5 * 60 && (expiredTime - nowTime) > 0
            /*如果 < 5分钟，则说明即将过期*/
            return result
        },
        /*
        * 暂存所有挂起的请求
        */
        addRequest(cb) {
            EpetJs.Const.requestList.push(cb)
        },
        /**
         * 执行之前挂起的请求
         */
        execRequest(token) {
            EpetJs.Const.requestList.map(cb => cb(token))
        },
        /**
         * 查看私密文件
         */
        getPrivateFileUrl(url, type) {
            var pam = {
                object: url,
                type: type ? type : 2
            }
            EpetJs.Common.get(commonApi.getPrivateFileUrl).then((res) => {
                if (res.data.status_code == EpetJs.Const.successStatus) {
                    return res.data.data.url
                } else {
                    EpetJs.Common.message({
                        message: res.data.message,
                        type: "warning"
                    });
                }
            })
        }
    },
    Init: function () {
        var http = location.protocol;
        var host = location.host;
        EpetJs.Const.PROTOCOL = http;

        if (host.indexOf('local') != -1) {
            EpetJs.Const.DOMAIN = '.local.epet.com';
            EpetJs.Const.RESOURCE_URL = '//static.local.epet.com';
            EpetJs.Const.ENV = 'local';
        }

        if (host.indexOf('dev') != -1) {
            EpetJs.Const.DOMAIN = '.dev.epet.com';
            EpetJs.Const.RESOURCE_URL = '//static.dev.epet.com';
            EpetJs.Const.ENV = 'dev';
        }
    }

}

EpetJs.Init();
window.EpetJs = EpetJs
